export default __webpack_public_path__ + "static/media/front_end_loader.4869808f.png";